import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

/**
 * This will require and make global all components starting with **Base** (e.g BaseButton, BaseInput etc) or **Icon** (e.g IconPhone)
 */
const requireComponent = import.meta.glob('../components/**/*.(vue|js|svg)', {
    eager: true,  // Using eager loading to immediately import the components
})

const matchingComponents = Object.keys(requireComponent).reduce((components, path) => {
    const match = path.match(/(Base|Icon)[A-Z]\w+\.(vue|js|svg)$/)

    if (match) {
    // Extract the component name from the path
        const componentName = upperFirst(
            camelCase(
                path
                    .split('/')
                    .pop()
                    .replace(/\.\w+$/, '')  // Remove file extension
            )
        )

        // Add the component to the result object
        components[componentName] = requireComponent[path]
    }

    return components
}, {})

// Register components globally in Vue
Object.keys(matchingComponents).forEach(componentName => {
    const componentConfig = matchingComponents[componentName]
    Vue.component(
        componentName,
        componentConfig.default || componentConfig  // Register the component globally
    )
})
